module.exports = __webpack_public_path__ + "static/media/bloodThinner.c2a410f1.mp3";